export * from './paginator.module';
export * from './paginator.component';
export * from './paginator.props';